import { SET_PARAMS_GROUP, CLEAR_PARAMS_GROUP, SET_BULK_PARAMS_GROUP } from "constants/types";

const initialState = {
    search: "",
    page: 1,
    size: 10,
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_PARAMS_GROUP:
            return {
                ...state,
                [payload.key]: payload.value,
            };
        case SET_BULK_PARAMS_GROUP:
            return {
                ...state,
                ...payload, // Make sure payload contains valid keys like `search` or `page`
            };
        case CLEAR_PARAMS_GROUP:
            return {
                ...state,
                search: "",
                page: 1,
            };
        default:
            return state;
    }
}
